export default "__VITE_ASSET__DDLm$CD6__"